import Swiper from 'swiper/bundle';
import {Navigation, Pagination} from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
function heroslider() {
	const slidersv1 = document.querySelectorAll('.hero-v1-swiper.swiper');
	const slidersv2 = document.querySelectorAll('.hero-v2-swiper.swiper');

	slidersv1.forEach((slider) => {
		new Swiper(slider, {
			loop: true,
			spaceBetween: 0,
			slidesPerView: 1,
			pagination: {
				el: '.swiper-pagination',
				clickable: true,
			},
			on: {
				transitionStart: function () {
					var videos = document.querySelectorAll('video');
					if (videos) {
						Array.prototype.forEach.call(videos, function (video) {
							video.pause();
						});
					}
				},

				transitionEnd: function () {
					var activeIndex = this.activeIndex;
					var activeSlide = document.getElementsByClassName('swiper-slide')[activeIndex];
					var activeSlideVideo = activeSlide.getElementsByTagName('video')[0];
					if (activeSlideVideo) {
						activeSlideVideo.play();
					}
				},
			}
		});
	});

	slidersv2.forEach((slider) => {
		new Swiper(slider, {
			loop: true,
			spaceBetween: 0,
			slidesPerView: 1,
			pagination: {
				el: '.swiper-pagination',
				clickable: true,
			},
		});
	});
}

function cardslider() {
	const sliders = document.querySelectorAll('.card-swiper.swiper');

	sliders.forEach((slider) => {
		new Swiper(slider, {
			loop: false,
			modules: [Navigation, Pagination],
			slidesPerView: 'auto',
			spaceBetween: 25,
			navigation: {
				nextEl: '.swiper-button-next',
				prevEl: '.swiper-button-prev',
			},
			scrollbar: {
				el: ".swiper-scrollbar",
				draggable: true,
			},
		});
	});

}

function productimagesslider() {
	const sliders = document.querySelectorAll('.product-images-swiper.swiper');

	sliders.forEach((slider) => {
		new Swiper(slider, {
			loop: true,
			slidesPerView: 1,
			spaceBetween: 0,
			navigation: {
				nextEl: '.swiper-button-next-image',
				prevEl: '.swiper-button-prev-image',
			},
			pagination: {
				el: '.swiper-pagination',
			},
		});
	});

}
function subCatSwiper() {
	const sliders = document.querySelectorAll('.subCatSwiper');

	sliders.forEach((slider) => {
		const nextEl = slider.querySelector('.swiper-button-next');
		const prevEl = slider.querySelector('.swiper-button-prev');

		const swiper = new Swiper(slider, {
			loop: false,
			slidesPerView: 'auto',
			spaceBetween: 20,
			navigation: { nextEl, prevEl },
			observer: true,
			observeParents: true,
			on: {
				init() { toggleNav(this); },
				resize() { toggleNav(this); },
				update() { toggleNav(this); },
			},
		});

		function toggleNav(sw) {
			const canScroll = sw.wrapperEl.scrollWidth > sw.el.clientWidth + 1;
			if (nextEl) nextEl.style.display = canScroll ? '' : 'none';
			if (prevEl) prevEl.style.display = canScroll ? '' : 'none';
			sw.wrapperEl.classList.toggle('canScroll', canScroll);
			sw.allowTouchMove = canScroll;
			sw.el.classList.toggle('is-locked', !canScroll);
		}
	});
}


function galleryslider() {
	const sliders = document.querySelectorAll('.gallery-swiper.swiper');

	sliders.forEach((slider) => {
		const swiper = new Swiper(slider, {
			loop: false,
			slidesPerView: 'auto',
			spaceBetween: 15,
			pagination: {
				el: slider.querySelector(".swiper-pagination"),
				type: "progressbar",
			},
			navigation: {
				nextEl: slider.querySelector('.swiper-button-next'),
				prevEl: slider.querySelector('.swiper-button-prev'),
			},
			scrollbar: {
				el: slider.querySelector(".swiper-scrollbar"),
				draggable: true,
			},
			on: {
				afterInit(swiper) {
					updateLockedState(swiper);
				},
				resize(swiper) {
					updateLockedState(swiper);
				}
			}
		});

		// Hilfsfunktion
		function updateLockedState(swiper) {
			const prev = slider.querySelector('.swiper-button-prev');
			const next = slider.querySelector('.swiper-button-next');

			if (swiper.isLocked) {
				slider.classList.add('swiper-locked'); // deine eigene Klasse
				prev.style.display = 'none';
				next.style.display = 'none';
			} else {
				slider.classList.remove('swiper-locked');
				prev.style.display = '';
				next.style.display = '';
			}
		}
	});
}


function productsslider() {
	const sliders = document.querySelectorAll('.products-swiper.swiper');

	sliders.forEach((slider) => {
		const swiper = new Swiper(slider, {
			loop: false,
			slidesPerView: 1,
			spaceBetween: 15,
			scrollbar: {
				el: slider.querySelector(".swiper-scrollbar"), // wichtig: nicht global
				draggable: true,
			},
			navigation: {
				nextEl: slider.querySelector('.swiper-button-next'),
				prevEl: slider.querySelector('.swiper-button-prev'),
			},
			breakpoints: {
				640: {
					slidesPerView: 2,
				},
				1024: {
					slidesPerView: 3,
				},
				1280: {
					slidesPerView: 4,
				},
				1536: {
					slidesPerView: 5,
				}
			},
			on: {
				afterInit(swiper) {
					updateLockedState(swiper);
				},
				resize(swiper) {
					updateLockedState(swiper);
				}
			}
		});

		function updateLockedState(swiper) {
			const prev = slider.querySelector('.swiper-button-prev');
			const next = slider.querySelector('.swiper-button-next');

			if (swiper.isLocked) {
				slider.classList.add('swiper-locked');
				prev.style.display = 'none';
				next.style.display = 'none';
			} else {
				slider.classList.remove('swiper-locked');
				prev.style.display = '';
				next.style.display = '';
			}
		}
	});
}


function plattenformenslider() {
	const sliders = document.querySelectorAll('.plattenformen-swiper.swiper');

	sliders.forEach((slider) => {
		new Swiper(slider, {
			loop: false,
			// slidesPerView: 4,
			slidesPerView: 1,
			spaceBetween: 15,
			scrollbar: {
				el: ".swiper-scrollbar",
				draggable: true,
			},
			navigation: {
				nextEl: slider.querySelector('.swiper-button-next'),
				prevEl: slider.querySelector('.swiper-button-prev'),
			},
			breakpoints: {
				640: {
					slidesPerView: 2,
				},
				1024: {
					slidesPerView: 3,
				},
				1280: {
					slidesPerView: 4,
				}
			}
		});
	});

}

function serienproductsslider() {
	const sliders = document.querySelectorAll('.serie-products-swiper.swiper');

	sliders.forEach((slider) => {
		new Swiper(slider, {
			loop: false,
			// slidesPerView: 4,
			navigation: {
				nextEl: '.swiper-button-next-main',
				prevEl: '.swiper-button-prev-main',
			},
			slidesPerView: 1,
			spaceBetween: 15,
			scrollbar: {
				el: ".swiper-scrollbar",
				draggable: true,
			},
			breakpoints: {
				1024: {
					slidesPerView: 2,
				}
			}
		});
	});

}

export {
	heroslider,
	cardslider,
	productimagesslider,
	subCatSwiper,
	galleryslider,
	productsslider,
	plattenformenslider,
	serienproductsslider
}